export default "__VITE_ASSET__5GMfRijA__"